import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { InputModelWithSource } from '../../models';
import { InputWithSource } from '../../componentTypes';
import { GenericSelect } from '../../components';


const FirstPeriodTimeInput: InputWithSource = ({ input }) => <GenericSelect label={input.name} input={input} />;

FirstPeriodTimeInput.meta = {
    inputType: InputModelWithSource.name
};

export default observer(FirstPeriodTimeInput);
